
class  DataStruct  {

    constructor() {
        this.rowsId=0;
        this.rows=[]; 
        this.cols=[];
        this.hasCols=false;
        this.heads=[];
        this.keyHead=0;
        this.filters=[];
        this.filtersIndex=[];
        this.rowsNumber=0;
        this.totalNumber=0;
        this.selected=[];
        this.selectedCheckBox=[];
        this.oldOrderColIndex=-1;
        this.cv=null;
    }


}


export default DataStruct;
